module.exports = __webpack_public_path__ + "static/media/plants2.5ac16f03.jpg";